import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wpressr': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM419.3 166.6C404.2 201.1 389 235.6 373.7 270.1 371.3 275.6 366.8 278.3 360.7 278.3 337.7 278.3 314.7 278.4 291.7 278.3 286.6 278.3 283.4 280.2 281.3 285 271.2 308.6 260.7 332 250.4 355.5 248.9 359 246.3 360.8 242.5 360.8 196.5 360.8 150.6 360.8 104.7 360.8 101.5 360.8 99 359.7 96.9 357.4 85.7 345 74.5 332.7 63.3 320.4 60.6 317.5 60.5 314.2 62.1 310.7 70.7 291.1 79.3 271.6 87.9 252 100.9 222.7 113.8 193.3 126.7 163.9 128.4 160.1 131 158.3 135.2 158.3 149.5 158.4 163.7 158.3 178 158.3 184.2 158.4 187.2 163.2 184.6 168.9 171 199.7 157.4 230.5 143.9 261.3 138.2 274.3 132.5 287.3 126.8 300.3 122.9 309.2 133.9 312.2 137.7 305.9 138 305.5 136.3 310 167.7 238.2 169.1 235.1 171.2 233.8 174.5 233.8 189.7 233.9 204.9 233.8 220.2 233.8 225.7 233.8 228.1 237.5 225.8 242.6 217.5 261.5 209.1 280.5 200.8 299.5 195.9 310.9 208.9 312 212.1 304.8 212.2 304.7 240 241.5 244.3 231.6 246.3 227 249.7 225.1 254.7 225.1 281.1 225.2 307.5 225.1 333.9 225.2 346.4 225.2 347.9 211.5 337.8 211.5 312.6 211.6 287.3 211.6 262.1 211.6 255.8 211.6 254.2 209.1 256.8 203.3 262.6 190.2 268.4 177.2 274.1 164.1 275.8 160.1 278.6 158.3 282.9 158.3 306 158.4 308.9 158.3 413.7 158.3 419.8 158.3 421.7 161.1 419.3 166.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wpressr.js
// module id = 1Tfa
// module chunks = 144